import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, FileCheck, Calculator, ShieldCheck, Building2, UserCheck } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  FileCheck,
  Calculator,
  ShieldCheck,
  Building2,
  UserCheck
};

const ServicesSection = () => {
  return (
    <section className="section-spacing bg-white">
      <div className="container-main">
        {/* Section Header */}
        <div className="max-w-lg mb-10">
          <span className="caption mb-3 block">Nossos Serviços</span>
          <h2 className="heading-1 mb-4">Soluções integradas para o seu negócio</h2>
          <p className="body-medium">
            Serviços especializados com excelência técnica e atendimento personalizado.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div key={service.id} className="service-card">
                <div className="icon-box mb-4">
                  {IconComponent && <IconComponent size={20} />}
                </div>
                <h3 className="heading-4 mb-2">{service.title}</h3>
                <p className="body-small mb-4 flex-grow">
                  {service.shortDescription}
                </p>
                <Link 
                  to={`/servicos#${service.slug}`}
                  className="inline-flex items-center gap-1.5 text-[#3E6B2A] font-medium text-sm hover:gap-2 transition-all"
                >
                  Saiba mais
                  <ArrowRight size={14} />
                </Link>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <Link to="/servicos" className="btn-secondary">
            Ver todos os serviços
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
